import type { KeyboardEvent } from 'react';

export const submitOnEnter =
  (onSubmit: () => void) => (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSubmit();
    }
  };
